import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { DetailWrapper, Header, InnerHeader, NavBar } from './BigNav.styles';
import { Buttons } from './Buttons';
import { Tabs } from './Tabs';
import { TabDetail } from './TabDetail';
import { Logo, ProgressBar } from '../shared';
import { AnalyticsAttributesProvider } from '../../../components';
export function BigNav({ hasScrolled, isLoggedIn, model: { id, content: { goToBoardsText, logInText, progressBar, progressLabel, signUpText, startTransparent, tabs = [] } } }) {
    const [activeTab, setActiveTab] = useState();
    const innerHeightRef = useRef(null);
    const [detailHeight, setDetailHeight] = useState(0);
    function escPress(event) {
        if (event.key === 'Escape') {
            setActiveTab(undefined);
        }
    }
    //listen for escape key when tab is open
    useEffect(() => {
        if (activeTab !== undefined) {
            window.addEventListener('keydown', escPress);
            document.body.classList.add('prevent-scroll');
        }
        return () => {
            window.removeEventListener('keydown', escPress);
            document.body.classList.remove('prevent-scroll');
        };
    }, [activeTab]);
    //handle layout size changes
    useEffect(() => {
        if (!innerHeightRef.current || typeof ResizeObserver !== 'function')
            return;
        const observer = new ResizeObserver((entries) => {
            var _a, _b;
            setDetailHeight((_b = (_a = entries[0]) === null || _a === void 0 ? void 0 : _a.contentRect.height) !== null && _b !== void 0 ? _b : 0);
        });
        observer.observe(innerHeightRef.current);
        return () => observer.disconnect();
    }, [innerHeightRef]);
    return (_jsx(AnalyticsAttributesProvider, Object.assign({ value: { eventContainer: 'globalNav' } }, { children: _jsx(Header, Object.assign({ "data-open": activeTab !== undefined, onClick: () => setActiveTab(undefined), "data-testid": "bignav" }, { children: _jsxs(InnerHeader, Object.assign({ "data-active": hasScrolled || activeTab !== undefined, startTransparent: startTransparent, onClick: (e) => e.stopPropagation() }, { children: [_jsxs(NavBar, { children: [_jsx(Logo, { id: id }, void 0), tabs && (_jsx(Tabs, { activeTab: activeTab, setActiveTab: setActiveTab, tabs: tabs }, void 0)), _jsx(Buttons, { goToBoardsText: goToBoardsText, isLoggedIn: isLoggedIn, logInText: logInText, signUpText: signUpText, uuid: id }, void 0), progressBar && _jsx(ProgressBar, { progressLabel: progressLabel }, void 0)] }, void 0), tabs.filter((tab) => tab.type === 'uiHeaderNavTab') && (_jsx(DetailWrapper, Object.assign({ style: { height: detailHeight } }, { children: _jsx("div", Object.assign({ ref: innerHeightRef }, { children: tabs.map((tab, index) => tab.type === 'uiHeaderNavTab' && (_jsx("div", Object.assign({ style: {
                                    display: activeTab === index ? 'block' : 'none'
                                } }, { children: _jsx(TabDetail, { tab: tab, active: activeTab === index }, void 0) }), index))) }), void 0) }), void 0))] }), void 0) }), void 0) }), void 0));
}
//# sourceMappingURL=BigNav.js.map